import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MetaPageEnum } from '~/core/declaration/declaration';
import { MetaTagService } from '~/core/utils/global-utils/global-utils';
import { BreadcrumbserviceService } from '~/pages/breadcrumb/breadcrumbservice.service';
import { HtmlRoutePages } from '../../../app-routing.model';
@Component({
  selector: 'volvoFL-page',
  templateUrl: './volvoFL-page.component.html',
  styleUrls: ['./volvoFL-page.component.scss']
})
export class BGvolvoFLPageComponent {
  constructor(private router: Router,
    private metaTagService: MetaTagService,
    private breadCrumbService: BreadcrumbserviceService) { }
  ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.metaTagService.updateTagFor(MetaPageEnum.TruckModelsFL);
    });
    this.metaTagService.updateTagFor(MetaPageEnum.TruckModelsFL);
    //this.breadCrumbService.updateBreadcrumb('Buyer' + "'s " + 'Guide','Volvo FL',HtmlRoutePages.buyersGuide);
  }

  navigateToBuyersGuide() {
    this.router.navigate(['en-gb/' + HtmlRoutePages.buyersGuide]);
  }
}
